import { getEditorCanvasDocument } from '../get-editor-canvas-document';

/**
 * Inject styles into both main document and editor canvas iframe
 */
export const injectStyleIntoDocuments = (
	css: string,
	id: string,
	attributeName: string = 'data-block-style',
): HTMLStyleElement[] => {
	const styleElements: HTMLStyleElement[] = [];

	// Inject into main document
	const mainStyleElement = document.createElement( 'style' );
	mainStyleElement.textContent = css;
	mainStyleElement.setAttribute( attributeName, id );
	document.head.appendChild( mainStyleElement );
	styleElements.push( mainStyleElement );

	// Inject into iframe if it exists
	const iframeDoc = getEditorCanvasDocument();
	if ( iframeDoc ) {
		const iframeStyleElement = iframeDoc.createElement( 'style' );
		iframeStyleElement.textContent = css;
		iframeStyleElement.setAttribute( attributeName, id );
		iframeDoc.head.appendChild( iframeStyleElement );
		styleElements.push( iframeStyleElement );
	}

	return styleElements;
};
